import {BaseWidgetConfiguration, BaseWidgetConfigurationInput} from "../../../Contracts/WidgetTypes/BaseWidget";

interface DerivedInventoryAccess {
    experiences: string[];
    flexOffers: string[];
}

const uniqueValues = (values: string[]): string[] => [...new Set(values)];

/**
 * Resolves the `inventoryAccess` configuration.
 *
 * If `inventoryAccess` is provided (either via the API configuration or the
 * data-config), it is mapped as-is (missing sub-fields default to an empty array).
 * Otherwise it is derived from the widget-specific inventory: the `experiences`
 * become a deduplicated list of the provided experience ids and the `flexOffers`
 * a deduplicated list of the provided flex offers.
 *
 * @param inventoryAccess the inventory access provided in the input configuration, if any
 * @param derived the widget-specific experiences and flexOffers used as fallback
 * @returns the resolved inventoryAccess configuration
 */
export const applyInventoryAccess = (
    inventoryAccess: BaseWidgetConfigurationInput['inventoryAccess'],
    derived: DerivedInventoryAccess
): BaseWidgetConfiguration['inventoryAccess'] => {
    if (inventoryAccess) {
        return {
            experiences: inventoryAccess.experiences ?? [],
            flexOffers: inventoryAccess.flexOffers ?? [],
        };
    }
    return {
        experiences: uniqueValues(derived.experiences),
        flexOffers: uniqueValues(derived.flexOffers),
    };
};
